import { Button } from '@/components/ui/button'
import { ArrowLeft, Plus } from 'lucide-react'
import { Link } from 'react-router-dom'

import type { FC, MouseEvent } from 'react'

export interface SidePanelHeaderProps {
	/**
	 * When provided, displays the Add IconButton
	 */
	onAdd?: () => void
	/**
	 * When set, the back button is displayed
	 */
	backEnabled?: boolean
	/**
	 * Panel Title
	 */
	title: string

	onBackClicked?: () => void
}

export const SidePanelHeader: FC<SidePanelHeaderProps> = ({
	backEnabled,
	onAdd,
	onBackClicked,
	title,
}) => {
	return (
		<div className="flex h-12 items-center justify-between px-3 border-b bg-background border-r">
			<div className="flex items-center gap-2">
				{backEnabled && (
					<Button
						variant="ghost"
						size="icon"
						className="h-8 w-8 cursor-pointer"
						aria-label="Back"
						asChild
					>
						<Link
							to={'..'}
							onClick={(e: MouseEvent<HTMLAnchorElement>) => {
								// Only run side effects on an unmodified primary click
								if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
									return
								}
								onBackClicked?.()
							}}
						>
							<ArrowLeft className="h-4 w-4" />
						</Link>
					</Button>
				)}
				<h2 className="text-sm font-semibold uppercase">{title}</h2>
			</div>
			{onAdd && (
				<Button
					variant="ghost"
					size="icon"
					className="h-8 w-8 cursor-pointer"
					aria-label={`Add ${title}`}
					onClick={onAdd}
					type="button"
				>
					<Plus className="h-4 w-4" />
				</Button>
			)}
		</div>
	)
}
